import { render, staticRenderFns } from "./IconAchievementV52.vue?vue&type=template&id=839a810c"
import script from "./IconAchievementV52.vue?vue&type=script&lang=js"
export * from "./IconAchievementV52.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports